<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-19 11:03:15
 * @LastEditTime: 2022-11-02 16:01:53
 * @Description: 历史收款记录
 * @Param:
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\collectionRecord\recordList.vue
 -->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles recordList">
            <van-nav-bar
                title="历史收款记录"
                left-text="收款记录"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section class="van-pull-refresh">
                <van-search
                    v-model="keywords"
                    placeholder="请输入搜索关键词"
                    @search="search"
                ></van-search>
                <div class="list">
                    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                        <van-list
                            v-model="isUpLoading"
                            :finished="finished"
                            finished-text="没有更多了!"
                            @load="onLoad"
                            :immediate-check="false"
                        >
                            <ul class="list_content">
                                <template v-for="(item, index) in listData">
                                    <li :key="`list_${index}`">
                                        <div class="engineeringInfo" @click="collectionRecordEdit(item, index)">
                                            <h4 class="engineeringInfo_header">
                                                <span
                                                    class="state notSubmitted"
                                                    v-if="item.approval_status == 0"
                                                >
                                                    <i>未提交</i>
                                                </span>
                                                <span
                                                    class="state submitted"
                                                    v-if="item.approval_status == 1"
                                                >
                                                    <i>已提交</i>
                                                </span>
                                                <span
                                                    class="state confirmed"
                                                    v-if="item.approval_status == 2"
                                                >
                                                    <i>已确认</i>
                                                </span>
                                                <span
                                                    class="state returned"
                                                    v-if="item.approval_status == 3"
                                                >
                                                    <i>已退回</i>
                                                </span>
                                                <span class="headerName">{{ item.contract_number }}</span>
                                            </h4>
                                            <div class="engineeringInfo_content">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                    <span>收款编号:{{ item.proceeds_number }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                    <span>客户名称：{{ item.client_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_2.png" alt="">
                                                    <span>工程名称：{{ item.engineering_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_26.png" alt="">
                                                    <span>本期实收：{{ item.official_receipt }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>收款日期：{{ item.receipt_date }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                    <span>场站：{{ item.station_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                                    <span>收款方式：{{ item.proceeds_mode_name }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="btns-con">
                                            <div @click="deleteInfo(item, index)">
                                                <i class="btn">删除</i>
                                            </div>
                                            <div @click="recordAssociation(item)">
                                                <i class="btn">关联</i>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </van-list>
                    </van-pull-refresh>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'record-list',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/collectionRecord') {
            this.$store.commit('noKeepAlive', 'record-list');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 合同编号
            contract_number: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 分页
            pageindex: 1,
            // 列表总条数
            total: 0,
            // 列表数据
            listData: [],
            // 查询条件
            keywords: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.editCallback) {
            if (this.$route.params.listIndex) {
                this.listData[this.$route.params.listIndex] = this.$route.params.row;
                this.listData[this.$route.params.listIndex].approval_status = 1;
            } else {
                this.onRefresh();
            }
        }
    },
    async created() {
        this.contract_number = this.$route.params.row.contract_number;
        await this.gitListData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 下拉刷新
        onRefresh() {
            this.pageindex = 1;
            this.listData = [];
            this.gitListData();
        },
        // 上拉加载更多
        onLoad() {
            this.pageindex++;
            this.gitListData();
        },

        // 查询
        search() {
            this.onRefresh();
        },

        // 收款记录编辑
        collectionRecordEdit(row, index) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'addCollectionRecord',
                params: {
                    row: row,
                    type: 'edit',
                    listIndex: index,
                    parentName: 'recordList',
                },
            });
        },

        // 删除收款记录
        async deleteInfo(row, index) {
            const deleteRow = await this.deleteInfoRequest(row.apid);
            if (deleteRow) {
                this.listData.splice(index, 1);
                this.$toast.success('删除成功');
            }
        },

        // 获取列表数据
        async gitListData() {
            const res = await this.gitListDataRequest();
            if (res.rows.length > 0) {
                this.total = res.total;
                if (this.listData.length < 1 ) {
                    this.listData = res.rows;
                    this.finished = false;
                } else {
                    this.listData.push(...res.rows);
                }
                if (this.listData.length === this.total) {
                    this.finished = true;
                }
            } else {
                this.finished = true;
            }
            this.isLoading = false;
            this.isUpLoading = false;
            this.$forceUpdate();
        },

        // 记录关联
        recordAssociation(row) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'recordAssociation',
                params: {
                    row: row,
                },
            });
        },

        // 获取列表数据请求
        gitListDataRequest() {
            // eslint-disable-next-line max-len
            return this.$axios.$get(`/interfaceApi/sale/accounts/proceeds/get_accounts_proceeds_list?keyword=${this.keywords}&contract_number=${this.contract_number}&pageindex=${this.pageindex}&pagesize=3`, { defEx: true });
        },

        // 删除记录请求
        deleteInfoRequest(apid) {
            return this.$axios.$post(`/interfaceApi/sale/accounts/proceeds/delete/${apid}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.recordList
    height 100%
    section
        height calc(100% - 44rpx)
        position relative
        .list
            padding 0
            height calc(100% - 44rpx)
            background #F0F0F0
            .van-pull-refresh
                height 100%
                overflow scroll
                -webkit-overflow-scrolling touch
                .list_content
                    padding 0 14rpx
                    background #F0F0F0
                    li
                        width 100%
                        background #fff
                        overflow hidden
                        margin-bottom 15rpx
                        position relative
                        strong
                            color #d60110
                            position absolute
                            top 46rpx
                            right 15rpx
                        .engineeringInfo
                            .state
                                &.notSubmitted
                                    background-color #FF6600
                                &.submitted
                                    background-color #3495FB
                                &.confirmed
                                    background-color #00A84B
                                &.returned
                                    background-color #D6010F
</style>

